import PropTypes from "prop-types";
import { shallow } from "zustand/shallow";
import { getSecurityExposureLimitInputFields } from "../../../utils/helpers/intakeForm";

import Card from "../../Card";
import DynamicGroupField from "../../Form/DynamicGroupField";

import useIntakeFormStore from "../../../store/IntakeForm.store";

const SecurityExposureLimitCard = ({ id, headerIcon, isEnabled }) => {
  const [formState] = useIntakeFormStore(
    (state) => [state.data.formState, state.data.formOptions],
    shallow
  );

  const isLocked = formState.isFormLocked;

  const securityExposureLimitInputFields =
    getSecurityExposureLimitInputFields(formState);

  return (
    <Card
      id={id}
      title="Enter Account Security Exposure Limits"
      headerIcon={headerIcon}
      openByDefault={isEnabled}
      disabled={!isEnabled}
      errorCount={formState.accountRestrictionData.totalErrorCount}
    >
      <div className="card__content">
        <DynamicGroupField
          title=""
          fieldArrayName="securityLimitData"
          store="intake"
          inputFields={securityExposureLimitInputFields}
          disabled={!isEnabled || isLocked}
          isRequired={false}
          displayTotal={false}
        />
      </div>
    </Card>
  );
};

SecurityExposureLimitCard.propTypes = {
  id: PropTypes.string,
  headerIcon: PropTypes.string,
  isEnabled: PropTypes.bool,
};

export default SecurityExposureLimitCard;
